import { createSlice } from "@reduxjs/toolkit";

import { loadState } from "./localStorage";

const preloadedState = loadState();

const initialState = {
  ...preloadedState,
};

export const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {},
});
